import timeago from 'timeago.js';
new timeago().render($('time.timeago'));



// WEBPACK FOOTER //
// ./src/javascripts/platform/initializers/timeago.initializer.js